// Authentication configuration
export const USER_KEY = 'user';

export const API_ROUTES = {
  LOGIN: '/api/v1/auth/login',
  LOGOUT: '/api/v1/auth/logout',
  REFRESH: '/api/v1/auth/refresh',
};